var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 2.16699H16.2499C14.8133 2.16699 13.4356 2.73768 12.4198 3.7535C11.4039 4.76932 10.8333 6.14707 10.8333 7.58366V10.8337H7.58325V15.167H10.8333V23.8337H15.1666V15.167H18.4166L19.4999 10.8337H15.1666V7.58366C15.1666 7.29634 15.2807 7.02079 15.4839 6.81763C15.6871 6.61446 15.9626 6.50033 16.2499 6.50033H19.4999V2.16699Z",
    stroke: "#5775FF",
    strokeWidth: 1.73333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a2fc6d0ff300c8e6a4c0007846a947ab.svg";
export { ForwardRef as ReactComponent };